import { Stack } from "@mui/material";
import WorkingDays from "./WorkingDays";
import DrawModalities from "./DrawModalities";
import { IDrawModalities, IPayplanTermConditions, IWorkingDays } from "@/Settings/types/Common/model";
import TermsAndConditions from "./TermsAndConditions";
import { IMappedPosition } from "@/Common/types/positions/api";

type TModalitiesConfigurationProps = {
	locationId: string;
	position: string;
	mappedPositions?: IMappedPosition[];
	workingDays?: IWorkingDays[];
	drawModalities?: IDrawModalities[];
	payplanTermConditions?: IPayplanTermConditions[];
};

const ModalitiesConfiguration = (props: TModalitiesConfigurationProps) => {
	const { locationId, position, workingDays, drawModalities, payplanTermConditions, mappedPositions } = props;

	return (
		<Stack spacing={5} direction="row" sx={{ padding: "0px" }}>
			<WorkingDays locationId={locationId} position={position} workingDays={workingDays} />
			<DrawModalities locationId={locationId} position={position} drawModalities={drawModalities} />
			<TermsAndConditions
				locationId={locationId}
				position={position}
				payplanTermConditions={payplanTermConditions}
				mappedPositions={mappedPositions}
			/>
		</Stack>
	);
};

export default ModalitiesConfiguration;
